import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function GuiaIniciantesPage() {
  return <BlogArticleLayout slug="guia-iniciantes-hoobuy" />;
}